import { Component, OnInit, inject } from '@angular/core';
import { Hero } from '../hero/hero';
import { AboutUs } from '../about-us/about-us';
import { OurServices } from '../our-services/our-services';
import { Testimonials } from '../testimonials/testimonials';
import { ContactUs } from '../contact-us/contact-us';
import { SliderUpdated } from '../slider-updated/slider-updated';
import { SeoService } from '../../Services/seo.service';

/**
 * Home page component
 * Main landing page that includes all primary sections and sets up SEO metadata
 */
@Component({
  selector: 'app-home',
  imports: [
    Hero,
    AboutUs,
    OurServices,
    Testimonials,
    ContactUs,
    SliderUpdated,
  ],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home implements OnInit {
  // SEO service for managing meta tags and structured data
  private readonly seoService = inject(SeoService);

  ngOnInit(): void {
    // Set up SEO meta tags for the home page
    this.setupSEO();
  }

  /**
   * Configures SEO meta tags and structured data for the home page
   */
  private setupSEO(): void {
    // Update meta tags for better search engine visibility
    this.seoService.updateMetaTags({
      title: 'Lexwood Solutions - Professional Timber Floor Installation, Sanding & Polishing in Sydney',
      description: 'Expert timber flooring services in Sydney with 15+ years of experience. Specializing in floor installation, dust-free sanding, and premium polishing using Bona, Loba, and Berger-Seidle systems. Fully qualified and insured.',
      keywords: 'timber floor installation Sydney, floor sanding Sydney, floor polishing Sydney, hardwood flooring Sydney, dust-free floor sanding, timber floor restoration, floor finishing Sydney, Lexwood Solutions',
      image: 'https://lexwoodsolutions.com/hero/hero-bg.jpeg',
      url: 'https://lexwoodsolutions.com/',
      type: 'website'
    });

    // Add structured data for organization
    this.seoService.addStructuredData({
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      'name': 'Lexwood Solutions',
      'description': 'Professional timber floor installation, sanding, and polishing services in Sydney',
      'url': 'https://lexwoodsolutions.com',
      'logo': 'https://lexwoodsolutions.com/Logos/lexwood-beige.svg',
      'image': 'https://lexwoodsolutions.com/hero/hero-bg.jpeg',
      'priceRange': '$$',
      'address': {
        '@type': 'PostalAddress',
        'addressLocality': 'Sydney',
        'addressRegion': 'NSW',
        'addressCountry': 'AU'
      },
      'geo': {
        '@type': 'GeoCoordinates',
        'latitude': '-33.8688',
        'longitude': '151.2093'
      },
      'openingHours': 'Mo-Sa 08:00-18:00',
      'areaServed': {
        '@type': 'City',
        'name': 'Sydney'
      },
      'hasOfferCatalog': {
        '@type': 'OfferCatalog',
        'name': 'Flooring Services',
        'itemListElement': [
          {
            '@type': 'Offer',
            'itemOffered': {
              '@type': 'Service',
              'name': 'Timber Floor Installation',
              'description': 'Professional installation of timber floors for residential and commercial spaces'
            }
          },
          {
            '@type': 'Offer',
            'itemOffered': {
              '@type': 'Service',
              'name': 'Floor Sanding',
              'description': 'Dust-free floor sanding using modern equipment'
            }
          },
          {
            '@type': 'Offer',
            'itemOffered': {
              '@type': 'Service',
              'name': 'Floor Polishing and Finishing',
              'description': 'Premium floor polishing using Bona, Loba, Berger-Seidle and Senteco systems'
            }
          }
        ]
      }
    });
  }
}
